import { INTAKE_STAGE } from "@/models/intake";
import { defineStore } from "pinia";
import { ref, watch } from "vue";
import { PageChangeManager } from "@/models/intake";
import { useRoute, useRouter } from "vue-router";
export const useIntakeStore = defineStore("intake-store", () => {
    const route = useRoute();
    const router = useRouter();
    const intakeDocument = ref(null);
    const intakeOrder = ref(null);
    const insuranceCards = ref([]);
    const intakeToDos = ref([]);
    const stage = ref(INTAKE_STAGE.INTAKE);
    const pageManager = ref(new PageChangeManager([]));
    const readOnly = ref(route.query?.ro !== undefined);
    const pendingPageSave = ref(null);
    const alertMessage = ref(null);
    watch(() => route.query.ro, (newRo) => {
        readOnly.value = newRo !== undefined;
    });
    const setReadOnly = (value) => {
        const query = { ...route.query };
        if (!value && query.ro) {
            delete query.ro;
        }
        else if (value) {
            query.ro = "1";
        }
        if (route.query.ro !== query.ro) {
            router.replace({ name: route.name ?? "", params: route.params, query });
        }
    };
    const reset = () => {
        intakeDocument.value = null;
        intakeOrder.value = null;
        insuranceCards.value = [];
        intakeToDos.value = [];
        stage.value = INTAKE_STAGE.INTAKE;
        pageManager.value.pages = [];
        pendingPageSave.value = null;
    };
    const setPageManager = (pages) => {
        pageManager.value.pages = pages;
    };
    return {
        intakeDocument,
        intakeOrder,
        insuranceCards,
        intakeToDos,
        reset,
        readOnly,
        setReadOnly,
        stage,
        pageManager,
        pendingPageSave,
        setPageManager,
        alertMessage,
    };
});
